export default class APIFactory {
    adapter = null;
    options = null;

    constructor() {
        return this;
    }

    setAdapter(Adapter) {
        const adapterClass = new Adapter();
        this.adapter = adapterClass;

        return this;
    }

    getAdapter() {
        return this.adapter;
    }

    withParameters(options) {
        this.options = options;

        return this;
    }

    run(method) {
        if (typeof this.adapter[method] !== 'function') {
            return Promise.reject('Adapter method ' + method + ' is missing.');
        }
        const response = this.adapter[method](this.options);
        this.options = null;
        return response;
    }
}
